"use strict";

const GREY_STATUSES = ["not-applicable", "identified"];
const FEE_UNIT = "/yr";

var _compUnit = function (program) {
  return program.compRecurring ? "/dec." : null;
};

var _rateUnit = function (type) {
  switch (type) {
    case "cost-area-imp":
    case "cost-area":
    case "cost-roof-area":
    case "cost-bmp-footprint":
      return "$/sqft";
    case "cost-gallon":
    case "cost-bmp-vol-capacity":
    case "cost-gallon-consumed":
      return "$/gal";
    case "cost-pollution":
      return "$/lb";
    case "cost-percent":
    case "fee-percent":
      return "%";
    case "cost-fixed-val":
      return null;
    default:
      return null;
  }
};

const CostRecoveryPage = function () {
  const stringKey = "cost-recovery";
  const headerInformation = "Cost Recovery";

  let $page;

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function (options) {
    $page = $("#inventory-modal .modal-dynamic-content").assertLength(1);
    const data = PropertyCostsModalController.getAllData();

    _removeUnknownFromStatusOptions(data);
    _addDefaultValues(data);
    await PropertyCostsModalController.renderPageContent(
      nunjucks.render("esg/modals/propertyCosts/costRecoveryPage.njk", data),
    );
    CollapsingCard.initializeCards($("#inventory-modal"));
    _loadListeners();
    updateCostRecoveryPrograms();
    _updateDefaultValues(data);
  };

  var _loadListeners = function () {
    Form.initializeAndLoadListeners($page, PropertyCostsModalController.getFormKey(), {
      isMultiPart: true,
    });
    $page.on("input", ".card select[name*=compStatus]", _onUpdateStatus);
    $page.on(
      "change",
      "[name*=useManualCompensationValue], [name*=useManualFeeValue], [name*=useManualFeeGrowthCoeff]",
      _onManualToggle,
    );
    $page.on("input", "[name*=compValueManual]", "useManualCompensationValue", _onManualValueInput);
    $page.on("input", "[name*=feeValueManual]", "useManualFeeValue", _onManualValueInput);
    $page.on(
      "input",
      "[name*=feeGrowthCoeffManual]",
      "useManualFeeGrowthCoeff",
      _onManualValueInput,
    );
    $page.on(
      "input change",
      "[name*=loanAmount], [name*=loanTerm], [name*=interestRate], [name*=marketInterestRate]",
      updateCostRecoveryPrograms,
    );
    $page.on("input change", "[name*=incentivePrograms]", _addIndexToIncentiveProgramData);
    $page.find(".card").on("hide.bs.collapse", _onCollapse);
  };

  var _unloadListeners = function () {
    $page.off("input", ".card select[name*=compStatus]", _onUpdateStatus);
    $page.off(
      "change",
      "[name*=useManualCompensationValue], [name*=useManualFeeValue], [name*=useManualFeeGrowthCoeff]",
      _onManualToggle,
    );
    $page.off("input", "[name*=compValueManual]", _onManualValueInput);
    $page.off("input", "[name*=feeValueManual]", _onManualValueInput);
    $page.off("input", "[name*=feeGrowthCoeffManual]", _onManualValueInput);
    $page.off(
      "input change",
      "[name*=loanAmount], [name*=loanTerm], [name*=interestRate], [name*=marketInterestRate]",
      updateCostRecoveryPrograms,
    );
    $page.off("input change", "[name*=incentivePrograms]", _addIndexToIncentiveProgramData);
    $page.find(".card").off("hide.bs.collapse", _onCollapse);
  };

  var _onUpdateStatus = function () {
    _updateCardStatus($(this));
    updateCostRecoveryPrograms();
  };

  var _onCollapse = function () {
    updateCostRecoveryPrograms();
  };

  var _addDefaultValues = function (data) {
    if (!data.incentivePrograms?.length) return;
    data.incentivePrograms.forEach((program) => {
      program.compValueManual = program.compValueManual || getCompensation(program, data);
      program.maxCompValue = getCompensationMax(program, data);
      program.statusText = _statusText(program);
      program.feeUnit = FEE_UNIT;
      program.compUnit = _compUnit(program);
      program.compRateUnit = _rateUnit(program.compensationType);
      program.feeRateUnit = _rateUnit(program.feeType);
    });
  };

  var _updateDefaultValues = function (data) {
    if (!data.incentivePrograms?.length) return;
    PropertyCostsModalController.setData("incentivePrograms", data.incentivePrograms);
  };

  var _statusText = function (program) {
    const status = NunjucksFilters.kebabToCapFirstLetters(program.compStatus);
    const value = NunjucksFilters.money(_compValue(program, true), { noCents: true });
    return `${status} - ${value}`;
  };

  var _compValue = function (program, ignoreNA = false) {
    const property = PropertyCostsModalController.getAllData();
    if (GREY_STATUSES.includes(program.compStatus) && !ignoreNA) {
      return 0;
    }
    const value = program.useManualCompensationValue
      ? program.compValueManual
      : getCompensation(program, property);
    return parseFloat(value || 0);
  };

  var _setStatusHtml = function (program) {
    $(".card[data-id=" + program.id + "] .card-status").html(_statusText(program));
  };

  var _onManualToggle = function () {
    const $toggle = $(this);
    const $fieldset = $toggle.closest(".manual-override");
    $fieldset.toggleClass("manual", $toggle.is(":checked"));
    $fieldset.find(".manual-value input").select();
    updateCostRecoveryPrograms();
  };

  var _updateCardStatus = function ($select) {
    const $card = $select.closest(".card");
    const compStatus = $card.find("select[name*=compStatus]").val();
    $card.attr("data-status", compStatus);
  };

  var _addIndexToIncentiveProgramData = function () {
    const $card = $(this).closest(".card");
    PropertyCostsModalController.setData(
      ["incentivePrograms", $card.data("index"), "id"],
      $card.data("id"),
    );
  };

  var _onManualValueInput = function (event) {
    const $input = $(this);
    const toggleField = event.data;
    const index = $input.closest(".card").data("index");
    PropertyCostsModalController.setData(["incentivePrograms", index, toggleField], true);
    $input
      .closest(".manual-override")
      .addClass("manual")
      .find("[name*=useManual]")
      .prop("checked", true);
    updateCostRecoveryPrograms();
  };

  var updateCostRecoveryPrograms = function () {
    const data = PropertyCostsModalController.getAllData();
    let costRecovery = 0;

    data?.incentivePrograms?.forEach(function (program, idx) {
      const compensation = _compValue(program);
      costRecovery += compensation;
      PropertyCostsModalController.setData(["incentivePrograms", idx, "id"], program.id);
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "compValue"],
        _compValue(program),
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "compValueManual"],
        program.compValueManual,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "useManualCompensationValue"],
        program.useManualCompensationValue,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "feeValue"],
        program.feeValue,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "feeValueManual"],
        program.feeValueManual,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "useManualFeeValue"],
        program.useManualFeeValue,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "feeGrowthCoeffManual"],
        program.feeGrowthCoeffManual,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "useManualFeeGrowthCoeff"],
        program.useManualFeeGrowthCoeff,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "loanAmount"],
        program.loanAmount,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "loanTerm"],
        program.loanTerm,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "interestRate"],
        program.interestRate,
      );
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "marketInterestRate"],
        program.marketInterestRate,
      );
      const $card = $(`.card[data-id=${program.id}]`);
      const maxCompValue = getCompensationMax(program, data);
      PropertyCostsModalController.setData(
        ["incentivePrograms", idx, "maxCompValue"],
        maxCompValue,
      );
      $card.find(".max-comp-value").text(
        NunjucksFilters.money(maxCompValue, {
          noCents: true,
          whenNaN: NunjucksFilters.displayFallback,
        }),
      );
      _renderCalculatedValue($card.find("[name$='[compValueManual]']"), {
        value: _compValue(program, true),
        unit: _compUnit(program),
      });
      _renderCalculatedValue($card.find("[name$='[feeValueManual]']"), {
        value: getFeeValue(program, data),
        unit: FEE_UNIT,
      });
      _setStatusHtml(program);
    });

    const costCapital = data.costType === "fixed" ? data.costCapitalManual : data.costCapital || 0;
    const total = Math.round(costCapital - costRecovery);

    PropertyCostsModalController.setData("costRecovery", costRecovery);
    PropertyCostsModalController.setData(
      "costRecoveryPercent",
      costCapital === 0 ? 0 : 100 * (costRecovery / costCapital),
    );
    $('input[name="costRecovery"]').val(costRecovery);
    $(".capital-cost-equation .cost-recovery strong").text(
      NunjucksFilters.money(costRecovery, { noCents: true }),
    );
    PropertyCostsModalController.setData("costTotal", total);
    $("input[name=costTotal]").val(total);
    $(".capital-cost-equation .total-cost strong").text(
      NunjucksFilters.money(total, { noCents: true }),
    );
  };

  var _removeUnknownFromStatusOptions = function (data) {
    data.dropdownOptions.compensationStatus = data.dropdownOptions.compensationStatus.filter(
      (option) => option.value !== "unknown",
    );
  };

  var getCompensation = function (ip, p) {
    const _compTime = _resolveCompTime(ip);

    if (ip.programType === "pace") {
      return (
        _getLifetimeRecovery(
          ip.loanAmount,
          ip.loanTerm,
          ip.interestRate,
          ip.marketInterestRate,
          _compTime,
        ) || 0
      );
    }

    let _compensation, _costRecoveryConst, _newCompensationValue;

    if (ip.rate === null) {
      _compensation = null;
    }

    let _newCompCoeff;
    if (ip.programType === "stormwater-fee-reduction" && ip.compRecurring) {
      _newCompCoeff = ip.rate * _cagrMultiplier(_resolveFeeGrowthCoeff(ip), _compTime);
    } else if (ip.compRecurring) {
      _newCompCoeff = ip.rate * _compTime;
    } else {
      _newCompCoeff = ip.rate;
    }

    switch (ip.compensationType) {
      case "cost-area-imp":
        if (p.useManualImperviousAcres) {
          _costRecoveryConst = p.imperviousAcresManual * 43560;
        } else {
          _costRecoveryConst = p.imperviousAcres * 43560;
        }
        break;
      case "cost-area":
        _costRecoveryConst = p.propertyAcres * 43560;
        break;
      case "cost-gallon":
        _costRecoveryConst = p.swMngd;
        break;
      case "cost-percent":
        if (p.costType === "fixed") {
          _costRecoveryConst = p.costCapitalManual / 100.0;
        } else {
          _costRecoveryConst = p.costCapital / 100.0;
        }
        break;
      case "cost-fixed-val":
        _costRecoveryConst = 1;
        break;
      case "cost-pollution":
        _costRecoveryConst = p.pollMngd;
        break;
      case "cost-roof-area":
        if (p.useManualBuildingFootprint) {
          _costRecoveryConst = p.buildingFootprintManual;
        } else {
          _costRecoveryConst = p.buildingFootprint;
        }
        break;
      case "cost-bmp-vol-capacity":
        _costRecoveryConst = UnitConversion.acreFeetToGallons(p.targetCapacity);
        break;
      case "fee-percent":
        _costRecoveryConst = (_resolveFeeValue(ip, p) ?? 0) / 100;
        break;
      case "cost-gallon-consumed":
      case "cost-bmp-footprint":
      default:
        _costRecoveryConst = null;
        break;
    }

    _compensation = _costRecoveryConst === null ? null : _costRecoveryConst * _newCompCoeff;
    const _compensationMax = getCompensationMax(ip, p);

    if (_compensationMax === null) {
      _newCompensationValue = Math.round(_compensation);
    } else {
      _newCompensationValue = Math.round(Math.max(0, Math.min(_compensation, _compensationMax)));
    }

    return Number(_newCompensationValue) || 0;
  };

  var getCompensationMax = function (ip, p) {
    if (Number(ip.maxCompCoeff) === 0) {
      return null;
    }

    let maxCompTypeCoeff;
    switch (ip.maxCompType) {
      case "max-cost-fixed-val":
        maxCompTypeCoeff = 1;
        break;
      case "max-cost-perc":
        maxCompTypeCoeff = (p.costType === "fixed" ? p.costCapitalManual : p.costCapital) / 100;
        break;
      case "max-cost-area-imp":
        maxCompTypeCoeff =
          (p.useManualImperviousAcres ? p.imperviousAcresManual : p.imperviousAcres) * 43560;
        break;
      case "max-cost-area":
        maxCompTypeCoeff = p.propertyAcres * 43560;
        break;
      default:
        return null;
    }

    return ip.maxCompCoeff * maxCompTypeCoeff;
  };

  var _resolveFeeValue = function (ip, p) {
    return ip.useManualFeeValue ? Number(ip.feeValueManual) || 0 : getFeeValue(ip, p);
  };

  var _resolveFeeGrowthCoeff = function (ip) {
    return ip.useManualFeeGrowthCoeff ? ip.feeGrowthCoeffManual : ip.feeGrowthCoeff;
  };

  var _resolveCompTime = function (ip) {
    if (ip.compTimeMax === null || Number(ip.compTimeMax) === 0) {
      return ip.compTimeDefault;
    }
    return Math.min(ip.compTimeMax, ip.compTimeDefault) || 0;
  };

  // Mirrors CAGR calculation in api/database/functions/esg.property_incentive_program_compensation.sql
  var _cagrMultiplier = function (cagrPercent, years) {
    const cagr = (Number(cagrPercent) || 0) / 100;
    if (cagr === 0) {
      return years;
    }
    return (Math.pow(1 + cagr, years) - 1) / cagr;
  };

  // Mirrors fee calculation in api/database/functions/esg.property_incentive_program_compensation.sql
  var getFeeValue = function (ip, p) {
    if (ip.feeCoeff === null || ip.feeCoeff === undefined) {
      return null;
    }

    let feeConst;
    switch (ip.feeType) {
      case "cost-area-imp":
        feeConst =
          (p.useManualImperviousAcres ? p.imperviousAcresManual : p.imperviousAcres) * 43560;
        break;
      case "cost-area":
        feeConst = p.propertyAcres * 43560;
        break;
      case "cost-fixed-val":
        feeConst = 1;
        break;
      case "cost-percent":
        feeConst = (p.costType === "fixed" ? p.costCapitalManual : p.costCapital) / 100;
        break;
      case "cost-roof-area":
        feeConst = p.useManualBuildingFootprint ? p.buildingFootprintManual : p.buildingFootprint;
        break;
      default:
        feeConst = null;
        break;
    }

    if (feeConst === null || feeConst === undefined) {
      return null;
    }

    const result = Math.round(feeConst * ip.feeCoeff);
    return Number.isNaN(result) ? null : result;
  };

  // Mirrors PACE compensation calculation in api/database/functions/esg.property_incentive_program_compensation.sql
  var _getLifetimeRecovery = function (
    loanAmount,
    loanTerm,
    interestRate,
    marketInterestRate,
    compTime,
  ) {
    const principal = Number(loanAmount);
    const years = Number(loanTerm);

    if (!principal || principal <= 0 || !years || years <= 0) {
      return null;
    }

    const lifetimeSavings =
      _totalInterest(principal, years, marketInterestRate) -
      _totalInterest(principal, years, interestRate);

    if (years < compTime) {
      return Math.round(lifetimeSavings);
    }

    return Math.round((lifetimeSavings / years) * compTime);
  };

  var _totalInterest = function (principal, years, annualRatePercent) {
    const monthlyRate = (Number(annualRatePercent) || 0) / 100 / 12;
    const months = years * 12;

    if (monthlyRate === 0) {
      return 0;
    }

    const growthFactor = Math.pow(1 + monthlyRate, months);
    const monthlyPayment = (principal * monthlyRate * growthFactor) / (growthFactor - 1);
    return monthlyPayment * months - principal;
  };

  var _renderCalculatedValue = function ($input, context) {
    const html = nunjucks.render("esg/modals/propertyCosts/_calculatedDollarValue.njk", context);
    $input.closest(".manual-override").find(".calculated-value").html(html);
  };

  var validate = function () {
    return true;
  };

  var cleanUp = function () {
    _unloadListeners();
    return true;
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
    getCompensation,
    getCompensationMax,
    getFeeValue,
    _statusText,
    updateCostRecoveryPrograms,
  };
};

module.exports = CostRecoveryPage();

const CollapsingCard = require("../../../general/collapsingCard");
const PropertyCostsModalController = require("../propertyCostsModalController");
const NunjucksFilters = require("../../../general/nunjucksFilters");
const Form = require("../../../general/form");
const UnitConversion = require("../../../unitConversion");
